module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxCAMAAACrgNoQAAAAAXNSR0IArs4c6QAAAE5QTFRFAAAAAAD/YHB/YHCHaHCHaHiPZHSTYHWKZXWKXnKNZHSLZHSJZHSJY3OKY3OLY3WMZHSLY3OMY3WMY3OLZHOLY3OLY3OMZHOLZHSLZHSLcqQVdAAAABl0Uk5TAAEQICAgITAwMUBwgJCgr7/f3+7u7+/v/mo9lSUAAADgSURBVEjH5ZXdDoMgDEaR+TdlU+eQ+f4vuuhQipRSLxe/y3JOUpKmFeKqKfoXSF+k6kLNXtpU/fCgb1u9Nt6DgsIj3yNdr9KWGhMIivzjMJ8SFl53fGHlK8UWfrxgC5ZnCxvPFXaeKTieJwCeJUDeZ2rj5gdEAf7ASIl11BjHxxg/HOaqybJzTNmDfRLdS44pB7hPcGaZgRbwY2ROWmT4Vr4SuIBMa5zHBYJHBYrHBJJHBJoPhQQfCM8EHwhzgkcEfc9smMJE37gpbCl545zQvD8gY+TGeXspz8kbd6z/eb619yc1cbBuTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullScreen.png
// module id = FNRU
// module chunks = 1